import { Network } from '../../../../utils/network'
import { Events } from '../../../../utils/servicesEvents'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function updateKycStatus(data, onSuccessEvent, onErrorEvent) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response, Formatter)
  const onDoneEvent =
    parsedResponse.statusCode == 200 ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest(data) {
  const url = 'https://apis.ecoxurf.com/kyc/set/validation/marketplace'
  const statuses = {
    validated: 'validated',
    rejected: 'rejected',
    notFilled: 'notFilled',
  }

  const requestData = {
    id: data.id,
    status: statuses[data.status],
  }

  const response = await Network.sendPostRequest(url, requestData)
  return response
}

function parseResponse(response) {
  if (response && response.status.code === 200) {
    return {
      statusCode: 200,
      message: 'Status updated',
    }
  }
  if (response.status.code === 0) {
    return {
      success: false,
      message: 'error',
      networkError: true,
    }
  }
  return {
    success: false,
    message: 'error',
  }
}

export { updateKycStatus }
